import { gsap } from "gsap";

export default class StepBlock {
    constructor(elm) {
        this.elm = elm;

        this.step = this.elm.querySelector('[data-step]');
        this.imageElms = this.elm.querySelectorAll('.img');
        this.textElms = this.elm.querySelectorAll('[data-step-text]');

        this.content = this.elm.querySelector('[data-content]');

        this.slideCount = this.imageElms.length;
        this.zIndexCount = 1;

        this.init();
    }

    init() {

        this.activeSlide = 0;
        this.currentIndex = 0;

        let mm = gsap.matchMedia();

        mm.add({
            isDesktop: `(min-width: 576px)`,
            isMobile: `(max-width: 575px)`,
            reduceMotion: "(prefers-reduced-motion: reduce)"
          }, (context) => {

            let { isDesktop, isMobile, reduceMotion } = context.conditions;

            this.tl = gsap.timeline({
                scrollTrigger: {
                    trigger: isMobile ? this.step : this.elm,
                    start: "top top",
                    end: isMobile ? '+=' + (this.elm.scrollHeight * this.slideCount)*0.75 : '+=' + (this.elm.scrollHeight * this.slideCount)*0.75,
                    pin: isMobile ? this.step : this.elm,
                    pinSpacing: true,
                    anticipatePin: true,
                    scrub: true,
                    onRefresh: () => {
                        if(isMobile) {
                            this.setContentHeight();
                        } else {
                            this.unsetContentHeight();
                        }
                    }
                },
                onUpdate: () => {
                    const stepSize = 1 / this.slideCount;
                    this.currentIndex = parseInt(this.tl.progress() / stepSize);
                    if(this.currentIndex !== this.activeSlide && this.currentIndex !== this.slideCount) {
                        this.showSlide(this.currentIndex);
                    }
                }
            });

            this.tl.fromTo('progress', {
                value: 0,
            }, {
                value: 100,
                ease: 'none'
            });

        });

    }

    setContentHeight() {
        let heighestText = 0;
        this.textElms.forEach(elm => {
            let textHeight = elm.querySelector('[data-step-text-inner]').scrollHeight;
            if(textHeight>heighestText) {
                heighestText = textHeight;
            }
        });

        gsap.set(this.content, {
            height: heighestText
        });
    }

    unsetContentHeight() {
        this.content.style.removeProperty('height');
    }

    getDirection() {
        let direction = 1;
        if(this.tl.scrollTrigger) {
            direction = this.tl.scrollTrigger.direction;
        }
        return direction;
    }

    hideSlide(index) {
        const text = this.textElms[index];
        gsap.killTweensOf(text);
        gsap.to(text, {
            opacity: 0,
            translateY: this.getDirection()*-1+'0%',
            duration: 0.4,
            delay: 0,
            ease: 'sine.in',
        });
    }

    showSlide(index) {
        this.hideSlide(this.activeSlide);
        this.activeSlide = index;

        const image = this.imageElms[index];
        const text = this.textElms[index];

        // Show image
        gsap.set(image, {
            zIndex: this.zIndexCount,
            translateY: this.getDirection()+'00%',
            onComplete: () => {
                this.zIndexCount++;
                gsap.to(image, {
                    translateY: '0%',
                    duration: 0.8,
                    delay: 0,
                    ease: 'power2.inOut'
                });
            }
        });

        // Show text
        gsap.fromTo(text, {
            opacity: 0,
            translateY: this.getDirection()+'0%',
        }, {
            opacity: 1,
            translateY: '0%',
            duration: 0.4,
            delay: 0.4,
            ease: 'sine.out',
        });

    }

}